import React from 'react';
import classNames from 'classnames';
import styles from './Breadcrumbs.module.css';
import BreadcrumbsItem from './BreadcrumbsItem';
import { useBreadcrumbs } from './hooks';
import { isEmpty } from 'ramda';
import { SEO } from '../../constants/seo';

const Breadcrumbs = ({ className }) => {
  const breadcrumbs = useBreadcrumbs();

  if (isEmpty(breadcrumbs)) {
    return null;
  }

  return (
    <ol
      className={classNames(styles.component, className)}
      itemScope
      itemType={SEO.TYPES.LIST}
    >
      {breadcrumbs.map((el, index) => (
        <BreadcrumbsItem
          to={el.link}
          isActive={el.active}
          key={el.title}
          isExternal={el.isExternal}
          position={index + 1}
        >
          {el.title}
        </BreadcrumbsItem>
      ))}
    </ol>
  );
};

export default Breadcrumbs;
